import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { dmy } from "@/components/market/CartChanges";

const after = (a) => [
  a?.extra_employees != null && `${a.extra_employees} emp.`,
  a?.team_option === false && "−GPS",
  a?.robot_trieur === false && "−Robot",
  a?.paused && "pause",
].filter(Boolean).join(" · ");

// Admin → Abonnements: scheduled decreases / removals / pauses per REF, and paused businesses (nothing deleted).
export const ChangesCard = () => {
  const { t } = useI18n();
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/admin/revenue/carts/changes").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  if (!list?.length) return null;
  return (
    <section className="card-carbon min-w-0 space-y-3 rounded-2xl p-4" data-testid="admin-changes-card">
      <h2 className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-[var(--gold-bright)]"><CalendarClock className="h-4 w-4 shrink-0" /> {t("chg.adminTitle")}</h2>
      <ul className="min-w-0 space-y-1 text-xs">
        {list.map((r) => (
          <li key={`${r.key_id}-${r.ref}-${r.kind}-${r.mode}`} className="flex min-w-0 flex-wrap items-center gap-x-2 break-words text-neutral-300" data-testid={`admin-change-${r.ref}-${r.kind}`}>
            <span className="font-semibold text-white" dir="ltr">{r.ref}</span>
            {r.email && <span dir="ltr">{r.email}</span>}
            <span className={r.kind === "paused" ? "text-neutral-400" : "text-amber-300"}>{t(r.kind === "paused" ? "chg.paused" : "chg.scheduled")}</span>
            {r.kind === "scheduled" && <span>· {after(r.after)} · {t("cart.effect", { date: dmy(r.effective_at) })}</span>}
            {r.kind === "paused" && r.paused_at && <span>· {dmy(r.paused_at)}</span>}
          </li>
        ))}
      </ul>
    </section>
  );
};
